import { ChangeDetectionStrategy, Component } from '@angular/core';
import { isEmptyButtonLabel } from '@common/helpers/forms';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import type { PaginationSettingsFormGroup, PaginationSettingsFormType } from '@web/widgets/catalog-products/type';

import { CommonElementsModule } from '@web/widgets/common/common-elements.module';
import { CurrentPageSettingsComponent } from './current-page-settings/current-page-settings.component';
import { NextPageSettingsComponent } from './next-page-settings/next-page-settings.component';
import { PagesSettingsComponent } from './pages-settings/pages-settings.component';

@Component({
    selector: 'web-pagination-settings',
    templateUrl: './pagination-settings.component.html',
    styleUrls: ['./pagination-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonElementsModule, CurrentPageSettingsComponent, NextPageSettingsComponent, PagesSettingsComponent],
})
export class PaginationSettingsComponent extends WebBaseControlTypedSettingsComponent<PaginationSettingsFormGroup> {
    public get pagesButtonsFormGroup(): PaginationSettingsFormType['pagesButtons'] {
        return this.itemForm.get('pagesButtons') as PaginationSettingsFormType['pagesButtons'];
    }

    public get currentPageFormGroup(): PaginationSettingsFormType['currentPage'] {
        return this.itemForm.get('currentPage') as PaginationSettingsFormType['currentPage'];
    }

    public get nextPageFormGroup(): PaginationSettingsFormType['nextPage'] {
        return this.itemForm.get('nextPage') as PaginationSettingsFormType['nextPage'];
    }

    /** The next-page button needs a text, but only while it is switched on. */
    public get saveDisablePredicate(): boolean {
        return (
            Boolean(this.nextPageFormGroup?.get('isShowButton')?.value) &&
            isEmptyButtonLabel(this.nextPageFormGroup.get('label')?.value)
        );
    }
}
